import { AvailableConnection, ConnectionReference, ConnectionsConfiguration } from "@/types";
import { isManagedApiConnector } from "./connector";

export const removeConnectionReference = (connectionJson: ConnectionsConfiguration, connectionId: string, connectorId: string): ConnectionsConfiguration | undefined => {
  if (connectionJson.managedApiConnections) {
    for (const [key, conn] of Object.entries(connectionJson.managedApiConnections)) {
      if (conn.connection.id.toLowerCase() === connectionId.toLowerCase()) {
        const rest = Object.fromEntries(
          Object.entries(connectionJson.managedApiConnections).filter(([k]) => k !== key)
        );
        return { ...connectionJson, managedApiConnections: rest };
      }
    }
  }

  const connectionName = connectionId.split('/').slice(-1)[0] ?? '';
  // Search service provider connections by serviceProvider.id and connection name
  if (connectionJson.serviceProviderConnections) {
    for (const [key, conn] of Object.entries(connectionJson.serviceProviderConnections)) {
      if (conn.serviceProvider.id.toLowerCase() === connectorId.toLowerCase() && connectionName.toLowerCase() === key.toLowerCase()) {
        const rest = Object.fromEntries(
          Object.entries(connectionJson.serviceProviderConnections).filter(([k]) => k !== key)
        );
        return { ...connectionJson, serviceProviderConnections: rest };
      }
    }
  }

  // Search agent connections by modelProvider.id and connection name
  if (connectionJson.agentConnections) {
    for (const [key, conn] of Object.entries(connectionJson.agentConnections)) {
      if (conn.modelProvider?.id.toLowerCase() === connectorId.toLowerCase() && connectionName.toLowerCase() === key.toLowerCase()) {
        const rest = Object.fromEntries(
          Object.entries(connectionJson.agentConnections).filter(([k]) => k !== key)
        );
        return { ...connectionJson, agentConnections: rest };
      }
    }
  }

  // Search MCP connections by connection name
  if (connectionJson.agentMcpConnections) {
    for (const [key] of Object.entries(connectionJson.agentMcpConnections)) {
      if (connectionName.toLowerCase() === key.toLowerCase()) {
        const rest = Object.fromEntries(
          Object.entries(connectionJson.agentMcpConnections).filter(([k]) => k !== key)
        );
        return { ...connectionJson, agentMcpConnections: rest };
      }
    }
  }

  return undefined;
}

export const getValidConnections = (allConnections: AvailableConnection[]): AvailableConnection[] => {
  return allConnections.filter(conn => conn.status === 'connected');
};

export const referenceHasConnection = (reference: ConnectionReference, connections: AvailableConnection[]): boolean => {
  return isManagedApiConnector(reference?.api?.id)
    ? connections.some(conn => conn.id.toLowerCase() === reference?.connection?.id?.toLowerCase())
    : true;
};
